import { CompartmentCard } from "@/src/components/cards";
import { FetchableList } from "@/src/components/fetchableLists";
import { AppointmentType } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { uid } from "@/src/utils/utils";
import { useState } from "react";
import { UserCard } from "../users/userCard";
import { openTargetUsersDrawer } from "../users/usersHook";

export function AppointmentTypeUsersList({
  permissionType,
  appointmentType,
}: {
  permissionType: "canScheduleTypes" | "canValidateTypes";
  appointmentType: AppointmentType;
}) {
  let [searchKey, setSearchKey] = useState("");
  const [reload, setReload] = useState(0);

  let title = "";
  if (permissionType === "canValidateTypes")
    title = "Utilisateurs autorisés à valider";
  if (permissionType === "canScheduleTypes")
    title = "Utilisateurs autorisés à programmer";

  async function openChoiceDrawer() {
    let data = await apiFetch("users", "loadMany", {
      searchKey,
      canScheduleTypes:
        permissionType === "canScheduleTypes" && appointmentType.id
          ? [appointmentType.id]
          : undefined,
      canValidateTypes:
        permissionType === "canValidateTypes" && appointmentType.id
          ? [appointmentType.id]
          : undefined,
    });
    await openTargetUsersDrawer({
      targetUsers: data || [],
      serviceId: null,
      onConfirm: async (users) => {
        for (let user of users) {
          user[permissionType] ||= [];
          user[permissionType]?.push(appointmentType);
          await apiFetch("users", "addOne", { user });
        }

        for (let user of data || []) {
          if (users.find((u) => u.id === user.id)) continue;
          user[permissionType] ||= [];
          user[permissionType] = user[permissionType]?.filter(
            (item) => item?.id !== appointmentType.id
          );
          await apiFetch("users", "addOne", { user });
        }

        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={title}
      searchKey={searchKey}
      onSearch={(newValue) => {
        setSearchKey(newValue || "");
      }}
      onClick={async () => {
        await openChoiceDrawer();
      }}
    >
      <FetchableList
        queryKey={[
          "AppointmentTypeUsersList",
          searchKey,
          permissionType,
          appointmentType.id,
          reload,
        ]}
        queryFn={() =>
          apiFetch("users", "loadMany", {
            searchKey,
            canScheduleTypes:
              permissionType === "canScheduleTypes" && appointmentType.id
                ? [appointmentType.id]
                : undefined,
            canValidateTypes:
              permissionType === "canValidateTypes" && appointmentType.id
                ? [appointmentType.id]
                : undefined,
          })
        }
      >
        {(data) => (
          <div className={`usersList grid c1 mc1 gap10`}>
            {data?.map((user) => {
              return (
                <UserCard
                  key={uid()}
                  user={user}
                  onClick={async () => {
                    await openChoiceDrawer();
                  }}
                ></UserCard>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}
